module.exports = __webpack_public_path__ + "img/model1.738dfe9b.png";